import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/SupplierAgentCommission`;

const headers = {
  'Content-Type': 'multipart/form-data',

};
const ApiSupplierAgentCommission = {
  getAllSuppliersByAgentId: (params) => {
    const url = `${baseServiceUrl}/GetAllSuppliersByAgentId`;
    return ServiceApi.get(url, { params });
  },
  getSupplierAgentCommissionsWithoutPagination: (params) => {
    const url = `${baseServiceUrl}/GetSupplierAgentCommissions`;
    return ServiceApi.get(url, { params });
  },
  getSupplierAgentCommissionById: (params) => {
    const url = `${baseServiceUrl}/GetSupplierAgentCommissionById`;
    return ServiceApi.get(url, { params });
  },
  editSupplierAgentCommission: (params) => {
    const url = `${baseServiceUrl}/EditSupplierAgentCommission`;
    return ServiceApi.post(url, params, { headers });
  },
  editSupplierAgentCommissionInGroup: (params) => {
    const url = `${baseServiceUrl}/EditSupplierAgentCommissionInGroup`;
    return ServiceApi.post(url, params, { headers });
  },
  getAllSupplierAgentCommissions: (params) => {
    const url = `${baseServiceUrl}/GetAllSupplierAgentCommissions`;
    return ServiceApi.get(url, { params });
  },
  createOrEditSupplierAgentCommissionCommand: (params)=>{
    const url = `${baseServiceUrl}/createOrEditSupplierAgentCommissionCommand`;
    return ServiceApi.post(url,params);
  }
};

export default ApiSupplierAgentCommission;


